import { useCallback, useRef } from 'react';

// Guards against out-of-order async responses — e.g. a fetch kicked off for
// the EN profile that resolves after the user has already switched to PL.
// Call start() right before the async work; only apply state updates when
// the returned isCurrent() still returns true.
export function useRequestGuard() {
  const tokenRef = useRef(0);
  const start = useCallback(() => {
    const token = ++tokenRef.current;
    return () => tokenRef.current === token;
  }, []);
  return start;
}
